<template>
  <div class="process-button" @click="onClick" :key="key">
    <slot :processParams="innerParams"></slot>
  </div>
</template>
<script>
/**
 * @param ProcessButton
 *
 * @description A ProcessBuilder gombjainak megjelenítése
 */
import notify from '../../utils/mixin-notify'

export default {
  name: 'ProcessButton',
  mixins: [notify],
  props: {
    id: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    callback: {
      type: String,
      required: false,
    },
    pb: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      key: 1,
      innerParams: {},
    }
  },
  methods: {
    onClick() {
      const params = {
        id: this.id,
        ...this.innerParams,
      }
      this.$client
        .execute({
          operationId: 'ProcessBuilder_runProcess',
          parameters: params,
        })
        .then(() => {
          if (this.callback && this.callback.length) {
            try {
              window.UserDefined[this.callback].call(this)
            } catch (e) {
              // @todo log
              console.error(e.message)
            }
          }
          this.key++
        })
        .catch(() => {
          const noty = {
            text: 'error_occured_during_the_process',
            type: 'info',
          }
          this.showNotification(noty)
        })
    },
  },
  mounted() {
    this.innerParams = this.params
  },
  watch: {
    params: {
      immediate: true,
      deep: true,
      handler: function () {
        this.innerParams = this.params
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.process-button {
  cursor: pointer;
}
</style>
